import React from "react";
import { SUB_DIRCTORY } from "../../../app_config";

const BookingRevenueSummaryRoute = [
  {
    path: `${SUB_DIRCTORY}/Booking-Revenue-Summary`,
    component: React.lazy(() => import("./BookingRevenueSummaryList")),
  },
];

export default BookingRevenueSummaryRoute;
